import { render, staticRenderFns } from "./RecentTypeView.vue?vue&type=template&id=6f40459c&scoped=true"
import script from "./RecentTypeView.vue?vue&type=script&lang=js"
export * from "./RecentTypeView.vue?vue&type=script&lang=js"
import style0 from "./RecentTypeView.vue?vue&type=style&index=0&id=6f40459c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40459c",
  null
  
)

export default component.exports